import { useEffect, useReducer, useState, useRef } from 'react'
import { StyledModalTableClientes } from '../../Styled.jsx';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAuth } from '../../../../context/AuthContext.jsx';
import { formatearFecha } from '../../../Utils/Utils.ts';
import { createIntervencion, getClienteOptions, getEquiposByPlantas2, getEquiposOptions, getLastIntervencionesByEquipo, getPlantabyCliente2, getPlantaOptions, updateIntervecion, getCheckIntervencion } from '../../../../api/Clientes.js';
import { getTipoEventosOptions } from '../../../../api/Configuracion.js';
import { formatearFechaDos } from '../../../Utils/Utils.ts';
import ModalDuplicate from './ViewMuestras/Items/ModalDuplicate.jsx';
import Input from '../../../Input/Input.jsx';
import CustomButton from '../../../Button/CustomButton.tsx';
import Tables from '../../../Tables/Tables.jsx';
import dayjs from 'dayjs';
import Preloader from '../../../Preloader/Preloader.jsx';
import Toast from '../../../Toast/Toast.jsx';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { getEquipoByOptionsIntervenciones } from '../../../../api/Intervenciones.ts';
const columns = [
  { id: "fecha", label: "Fecha" },
  { id: "tipodeevento", label: "Tipo de evento" },
];

const IntervencionesClientesExternosModal = (props) => {
  dayjs.extend(customParseFormat);
  const contadorCambiosNormal = useRef(0);

  const { token } = useAuth(); // Accede al token del contexto
  const propsIntervenciones = (datosUnidades) => {
    const ver = datosUnidades?.button === "ver" ?? false;
    const editar = datosUnidades?.button === "editar" ?? false;
    const datos = datosUnidades?.datos ?? [];
    return { ver, editar, datos };
  };
  const { ver, editar, datos } = propsIntervenciones(props.datos);
  const [formCompleto, setFormCompleto] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [clientes, setClientes] = useState([]);
  const [plantas, setPlantas] = useState([]);
  const [tipoEventos, setTipoEventos] = useState([]);
  const [equipos, setEquipos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [componentes, setComponente] = useState([]);
  const [lubricantes, setLubricantes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [plantaSeleccionado, setPlantaSeleccionado] = useState("");
  const [intervencionesEquipos, setIntervencionesEquipos] = useState([]);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [selectedOptioncli, setSelectedOptioncli] = useState(null);
  const [selectedOptionequi, setSelectedOptionequi] = useState(null);
  const [selectedOptionepla, setSelectedOptionpla] = useState(null);
  const [selectedOptiontpeve, setSelectedOptiontpeve] = useState(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [form, setForm] = useReducer(
    (state, action) => {
      switch (action.type) {
        case "SET_FIELD":
          return { ...state, [action.field]: action.value };
        default:
          return state;
      }
    },
    {
      id: datos.id ?? "",
      cliente: token.clienteId !== ""
        ? parseInt(token.clienteId, 10)
        : datos.clienteId
          ? datos.clienteId
          : "",
      planta: token.plantaId === ""
        ? datos.plantaId ?? ""
        : token.plantaId.split(",").length === 1
          ? token.plantaId
          : datos.plantaId ?? "",
      equipo: datos.equipoId ?? "",
      tipodeevento: datos.tipoId ?? "",
      clienteId: datos.cliente ?? "",
      plantaId: datos.planta ?? "",
      equipoId: datos.equipo ?? "",
      tipodeeventoId: datos.tipoId ?? "",
      fechadeevento: dayjs(datos.fecha, "DD/MM/YYYY"),
      detalledelevento: datos.detallesDelEvento ?? "",
      observaciones: datos.observaciones ?? "",
    }
  );



  useEffect(() => {
    if (
      selectedOptioncli === "" ||
      selectedOptioncli === null ||
      selectedOptioncli === undefined
    ) {
      return;
    }
    if (loadingEdit) {


      getPlantabyCliente2(selectedOptioncli?.value).then((res) => {
        let aux = res.data.map((res) => {
          return { label: res.desc_pla, value: res.id, subLabel: res.cliente.description, };
        });

        // Si token.plantaId no está vacío, se aplica el filtro
        if (token.plantaId !== "") {
          const plantaIds = token.plantaId.split(',').map(id => id.trim());
          aux = aux.filter(option => plantaIds.includes(option.value.toString()));

          // Si es un único número, se filtra por ese número específico
          if (plantaIds.length === 1) {
            const matchOption = aux.find((option) => option.value === parseInt(plantaIds[0]));
            setSelectedOptionpla(matchOption);
          } else {
            // Si hay varios números, buscamos el que coincida con el label en aux filtrado
            const matchOption = aux.find((option) => option.label === datos.planta);
            setSelectedOptionpla(matchOption);
          }
        } else {
          const matchOption = aux.find((option) => option.label === datos.planta);
          setSelectedOptionpla(matchOption);
        }

        // Establecer las plantas (filtradas si es necesario)
        setPlantas(aux);
      });
      return;
    }
    if (form.cliente !== "" && !ver && selectedOptioncli !== null) {
      setSelectedOptionequi("");
      setSelectedOptionpla("");
      setEquipos([]);
      setPlantas([]);
      getPlantabyCliente2(selectedOptioncli.value).then((res) => {
        let aux = res.data.map((res) => {
          return { label: res.desc_pla, value: res.id, subLabel: res.cliente.description, };
        });

        // Si token.plantaId no está vacío, se aplica el filtro
        if (token.plantaId !== "") {
          const plantaIds = token.plantaId.split(',').map(id => id.trim());
          aux = aux.filter(option => plantaIds.includes(option.value.toString()));

          // Si es un único número, se filtra por ese número específico
          if (plantaIds.length === 1) {
            const matchOption = aux.find((option) => option.value === parseInt(plantaIds[0]));
            setSelectedOptionpla(matchOption);
          } else {
            // Si hay varios números, buscamos el que coincida con el label en aux filtrado
            const matchOption = aux.find((option) => option.label === datos.planta);
            setSelectedOptionpla(matchOption);
          }
        } else {
          const matchOption = aux.find((option) => option.label === datos.planta);
          setSelectedOptionpla(matchOption);
        }

        // Establecer las plantas (filtradas si es necesario)
        setPlantas(aux);
      });
    }
  }, [selectedOptioncli]);

  useEffect(() => {
    if (
      selectedOptionepla === "" ||
      selectedOptionepla === null ||
      selectedOptionepla === undefined
    ) {
      return;
    }

    if (loadingEdit) {
      getEquiposByPlantas2(selectedOptionepla?.value).then((res) => {
        const aux = res.data.map((res) => ({
          label: res.desc_equi,
          value: res.id,
          code: res.codigo_equi
        }));
        setEquipos(aux);

        const matchOption = aux.find((option) => option.label === datos.equipo);
        setSelectedOptionequi(matchOption);
        setLoadingEdit(false);
      });
      return;
    }

    if (form.cliente !== "" && !ver) {
      if (!selectedOptionepla?.value) return;

      if (editar) {
        // en editar lo seteo de una
        setSelectedOptionequi(null);
      } else {
        // en el segundo
        contadorCambiosNormal.current += 1;
        if (contadorCambiosNormal.current >= 2) {
          setSelectedOptionequi(null);
        }
      }
      getEquiposByPlantas2(selectedOptionepla?.value).then((res) => {
        setEquipos(
          res.data.map((res) => ({
            label: res.desc_equi,
            value: res.id,
            code: res.codigo_equi
          }))
        );
      });
    }
  }, [selectedOptionepla]);

  useEffect(() => {
    if (
      selectedOptioncli === null ||
      !selectedOptionequi ||
      Array.isArray(selectedOptionequi) ||
      selectedOptionequi.value === undefined ||
      isNaN(selectedOptionequi.value)
    ) {
      return;
    }

    if (form.cliente !== "") {
      getLastIntervencionesByEquipo(selectedOptionequi.value).then((res) => {
        setIntervencionesEquipos(
          res.data.map((res) => {
            return {
              fecha: formatearFecha(res.fecha_inte),
              tipodeevento: res.tipo.description,
            };
          })
        );
      });
    }
  }, [selectedOptionequi]);

  useEffect(() => {
    const camposValidos = [
      selectedOptioncli,
      selectedOptionepla,
      selectedOptionequi,
    ].every((opt) => opt !== null && opt !== "");

    const esFechaValida =
      form.fechadeevento && dayjs(form.fechadeevento).isValid();

    const camposFormValidos =
      form.tipodeevento !== "" &&
      esFechaValida &&
      form.detalledelevento !== "";

    setFormCompleto(camposValidos && camposFormValidos);
  }, [form, selectedOptioncli, selectedOptionepla, selectedOptionequi]);


  useEffect(() => {
    const fetchclientes = async () => {
      const res = await getClienteOptions();
      const unidades = res?.data?.map((item) => ({
        value: item.id,
        label: item.desc_cli,
      }));
      setClientes(unidades);

      if (datos) {
        const matchOption = unidades.find(
          (option) => option.label === datos.cliente
        );
        if (matchOption) {
          setSelectedOptioncli(matchOption);
        } else if (unidades.length > 0 && editar) {
          setSelectedOptioncli(unidades[0]);
        }
      } else if (unidades.length > 0 && editar) {
        setSelectedOptioncli(unidades[0]);
      }

      if (datos.length === 0 && token.clienteId !== "") {

        const matchOption = unidades.find(
          (option) => option.value === parseInt(token.clienteId, 10)
        );

        if (matchOption) {
          setSelectedOptioncli(matchOption);
        }
      }
    };


    const fetchEquipos = async () => {
      const res = await getEquiposOptions();

      const unidades = res?.data?.map((item) => ({
        value: item.id,
        label: item.desc_equi,
        code: item.codigo_equi
      }));
      setEquipos(unidades);
      if (datos) {
        const matchOption = unidades.find(
          (option) => option.value === datos.equipoId
        );

        if (matchOption) {
          setSelectedOptionequi(matchOption);
        } else if (unidades.length > 0 && editar) {
          setSelectedOptionequi(unidades[0]);
        }
      } else if (unidades.length > 0 && editar) {
        setSelectedOptionequi(unidades[0]);
      }
    };

    const fetchPlantas = async () => {
      const res = await getPlantaOptions();
      const unidades = res?.data?.map((item) => ({
        value: item.id,
        label: item.desc_pla,
        subLabel: item.cliente.description,
      }));
      setPlantas(unidades);

      if (datos) {
        const matchOption = unidades.find(
          (option) => option.label === datos.planta
        );
        if (matchOption) {
          setSelectedOptionpla(matchOption);
        } else if (unidades.length > 0 && editar) {
          setSelectedOptionpla(unidades[0]);
        }
      } else if (unidades.length > 0 && editar) {
        setSelectedOptionpla(unidades[0]);
      }
    };

    const fetchTipoEventos = async () => {
      const res = await getTipoEventosOptions();
      const unidades = res?.data?.map((item) => ({
        value: item.id,
        label: item.desc_tpeve,
      }));
      setTipoEventos(unidades);

      if (datos) {
        const matchOption = unidades.find(
          (option) => option.label === datos.tipo
        );
        if (matchOption) {
          setSelectedOptiontpeve(matchOption);
        } else if (unidades.length > 0 && editar) {
          setSelectedOptiontpeve(unidades[0]);
        }
      } else if (unidades.length > 0 && editar) {
        setSelectedOptiontpeve(unidades[0]);
      }
    };

    const fetchEdit = async () => {
      const resClientes = await getClienteOptions();
      const unidades = resClientes?.data?.map((item) => ({
        value: item.id,
        label: item.desc_cli,
      }));
      setClientes(unidades);

      const matchOption = unidades.find(
        (option) => option.label === datos.cliente
      );
      setSelectedOptioncli(matchOption);
    };

    if (editar) {
      setLoadingEdit(true);
      fetchEdit();
    } else {
      fetchclientes();
      if (ver) {
        fetchPlantas();
      }
      if (ver) {
        fetchEquipos();
      }
    }
    fetchTipoEventos();

  }, []);

  useEffect(() => {
    if (!selectedOptioncli) return;

    getEquipoByOptionsIntervenciones(selectedOptioncli.value).then((res) => {
      const equiposMapped = res.data.map((item) => ({
        label: item.desc_equi,
        value: item.id,
        idPlanta: item.planta.id,
        planta: item.planta,
        code: item.codigo_equi
      }));

      setEquipos(equiposMapped);


      if (datos?.equipoId) {
        const matchEquipo = equiposMapped.find(
          (e) => e.value === datos.equipoId
        );
        if (matchEquipo) {
          setSelectedOptionequi(matchEquipo);
        }
      }
    });
  }, [selectedOptioncli]);
  useEffect(() => {
    if (!selectedOptionequi || !plantas.length) return;

    const idPlanta = selectedOptionequi.idPlanta;
    const plantaMatch = plantas.find((p) => p.value === idPlanta);

    if (plantaMatch) {
      setSelectedOptionpla(plantaMatch);
    }
  }, [selectedOptionequi, plantas]);




  const handleChange = (e, nameReactSelect) => {
    if (e.target) {
      const { name, value, checked, type } = e.target;
      const fieldValue = type === "checkbox" ? checked : value;
      setForm({ type: "SET_FIELD", field: name, value: fieldValue });
    } else {
      const value = e.value;
      const name = nameReactSelect;
      if (name === "cliente") {
        //setClienteSeleccionado(value);
        setSelectedOptioncli(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      } else if (name === "equipo") {
        setSelectedOptionequi(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      } else if (name === "planta") {
        setPlantaSeleccionado(value);
        setSelectedOptionpla(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      } else if (name === "tipodeevento") {
        setSelectedOptiontpeve(e);
        setForm({ type: "SET_FIELD", field: name, value: value });
      }
    }
  };


  const handleChangeCalendar = async (date, nameCalendar) => {
    const equipoId = form.equipo;
    const tipoEventoId = form.tipodeevento;
    const value = dayjs(date);
    const fecha = formatearFechaDos(value);
    const name = nameCalendar;

    try {
      const response = await getCheckIntervencion(equipoId, tipoEventoId, fecha);
      if (response.data === true) {
        setShowDuplicateModal(true);
      }
    } catch (err) {
      console.log(err)
    }

    if (ver) {
      return;
    }

    setForm({ type: "SET_FIELD", field: name, value: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const formattedData = {
          id: form.id,
          codigo_inte: "codigo", //no tengo
          abrev_inte: "abrev",
          desc_inte: form.detalledelevento,
          fecha_inte: form.fechadeevento, //@todo tiene que ir formateada a string asi como esta
          fecha_inte_str: "32132",
          observacion_inte: form.observaciones,
          tipo_id: form.tipodeevento.toString(),
          equipo_id: form.equipo.toString(),
          cliente_id: form.cliente.toString(),
          planta_id: form.planta ? form.planta.toString() : selectedOptionepla?.value,
          created_by: "dasfdasd",
          created_date: new Date(),
          last_modified_by: "1",
          last_modified_date: new Date(),
          status: "SI",
          eliminado: false,
          tenantId: "1",
        };
        const action = editar ? updateIntervecion : createIntervencion;
        const successMessage = editar
          ? "Intervención modificada con éxito."
          : "Intervención creada con éxito.";
        await action(formattedData);
        setIsLoading(false);
        props.onClick({ msj: successMessage, status: "success" });
      } catch (err) {
        setIsLoading(false);
        props.onClick({ msj: "Error en la operación.", status: "error" });
        setError(err.response ? err.response.data : err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  };

  const titulo = () => {
    const titulo = ver
      ? "Ver intervenciones"
      : editar
        ? "Editar intervenciones"
        : "Crear o editar intervenciones";
    return titulo;
  };

  const renderButtons = () => {
    return (
      <>
        <CustomButton
          onClick={props.onClick}
          label={ver ? "Cerrar" : "Cancelar"}
          variant="contained"
          className={`buttonColor${ver ? "Default" : "Disabled"} btn`}
        />
        {!ver && (
          <CustomButton
            label={"Confirmar"}
            variant="contained"
            className={`buttonColorDefault btn`}
            type="submit"
            disabled={!formCompleto}
          />
        )}
      </>
    );
  };

  return (
    <StyledModalTableClientes >
      <Preloader
        title="Cargando..."
        subtitle={"Espere unos Segundos por favor..."}
        loading={isLoading}
      />
      {showDuplicateModal && (
        <ModalDuplicate onClick={() => {
          setShowDuplicateModal(false);
        }}
          tipoEvento={selectedOptiontpeve.label ?? ""}
          equipo={selectedOptionequi.label ?? ""}
          fecha={formatearFecha(form.fechadeevento) ?? ""}
        />
      )}
      <div className="toast">

        {success ? (
          <Toast title={msjToast} close={() => setSuccess(false)} />
        ) : null}
        {error ? (
          <Toast
            type={"error"}
            title={
              "Error al " +
              (editar ? "modificar" : "crear") +
              "El punto de toma ?"
            }
            close={() => setError(false)}
          />
        ) : null}
      </div>
      <div className="intervenciones">
        <div className="divLabel">
          <p className="titulo"> {titulo()} </p>
        </div>

        <form className="formulario" onSubmit={handleSubmit}>
          <div className="divInputs">
            <div className="divUno">
              <div style={{ width: "50%" }}>
                <Input
                  reactSelect
                  options={clientes}
                  value={selectedOptioncli}
                  onChange={(e) => handleChange(e, "cliente")}
                  isDisabled={ver && true || token.clienteId !== ""}
                  placeholder={ver || token.clienteId || selectedOptioncli !== "" ? "Cliente" : "Selecciona el Cliente"}
                />
              </div>
              <div style={{ width: "50%" }}>
                <Input
                  reactSelect
                  options={plantas}
                  value={selectedOptionepla}
                  onChange={(e) => handleChange(e, "planta")}
                  isDisabled={
                    selectedOptioncli === null ||
                    selectedOptioncli === "" ||
                    ver ||
                    (token.plantaId && token.plantaId.split(',').length === 1)  // Si token.plantaId tiene un solo número
                  }
                  placeholder={(token.plantaId && token.plantaId.split(',').length === 1) || selectedOptionepla
                    ? "Planta" : ver ? "Planta" : "Selecciona la Planta"}
                  showSubLabel
                />
              </div>
            </div>
            <div className="divDos">
              <div style={{ width: "50%" }}>
                <Input
                  reactSelect
                  options={equipos}
                  value={selectedOptionequi}
                  onChange={(e) => handleChange(e, "equipo")}
                  isDisabled={
                    selectedOptionepla === null ||
                    selectedOptionepla === "" ||
                    ver
                  }
                  placeholder={ver || editar || selectedOptionequi ? "Equipo" : "Selecciona el Equipo"}
                  showSubLabel
                />
              </div>
              <div style={{ width: "50%" }}>
                <Input
                  reactSelect
                  options={tipoEventos}
                  value={selectedOptiontpeve}
                  onChange={(e) => handleChange(e, "tipodeevento")}
                  isDisabled={ver}
                  placeholder={
                    ver || selectedOptiontpeve ? "Tipo de Evento" : "Selecciona tipo de Evento"
                  }
                />
              </div>
            </div>
            <div className="divTres">
              <div className="divDate" style={{ width: "50%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      className="inputDate"
                      label="Fecha del Evento"
                      placeholder="Fecha del Evento"
                      value={form.fechadeevento}
                      onChange={(date) =>
                        handleChangeCalendar(date, "fechadeevento")
                      }
                      disabled={ver}
                      sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: '#163C5B',
                          color: '#163C5B',
                          opacity: 1,
                        },
                        '& .MuiInputBase-root.Mui-disabled': {
                          // backgroundColor: '#f8f7f7',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ccc',
                        },
                        '& .MuiInputLabel-root.Mui-disabled': {
                          color: '#163C5B',
                        }
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>

              <Input
                value={form.detalledelevento}
                label="Detalle del evento"
                classnamediv="divDetalleDelEvento"
                className="input inputDetalleDelEvento"
                variant="outlined"
                size={"medium"}
                name="detalledelevento"
                disabled={ver}
                onChange={handleChange}
              />
            </div>
            <div className="divCuatro">
              <Input
                value={form.observaciones}
                label="Observaciones"
                classnamediv="divObservaciones divInput"
                className="input inputObservaciones"
                variant="outlined"
                size={"medium"}
                name="observaciones"
                disabled={ver}
                onChange={handleChange}
              />
            </div>
            <div className="divButtonsItem">{renderButtons()}</div>
          </div>

          <div className="divTabla">
            <div className="divTitulo">
              <p className="titulo">Ultimas Intervenciones Registradas</p>
            </div>
            {selectedOptionequi?.value && (
              <Tables
                typeTable={"prop"}
                columns={columns}
                rows={intervencionesEquipos}
                cRows={7}
                page={(value) => {
                  //console.log(value);
                }}
              />
            )}
          </div>
        </form>
      </div>
    </StyledModalTableClientes>
  );
};

export default IntervencionesClientesExternosModal;
